import { Provider } from '@angular/core';
import { SubtasksHttpService } from './abstract';
import { SubtasksHttpServiceImpl } from './subtasks-http-service';

export const SubtasksHttpProvider: Provider = {
	provide: SubtasksHttpService,
	useClass: SubtasksHttpServiceImpl,
};
